// src/components/common/BackButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className="btn btn-outline-secondary d-flex align-items-center"
      title="Go Back"
      style={{ marginTop: '0.1rem' }}  
    >
      <FaArrowLeft className="me-2" />
      
    </button>
  );
};

export default BackButton;
